/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import BaseResponse from '../model/BaseResponse';
import EventsControllerDtoBannerListRequest from '../model/EventsControllerDtoBannerListRequest';
import EventsControllerDtoBannerListResponse from '../model/EventsControllerDtoBannerListResponse';
import EventsControllerDtoBannerRemoveRequest from '../model/EventsControllerDtoBannerRemoveRequest';
import EventsControllerDtoBannerSortUpdateRequest from '../model/EventsControllerDtoBannerSortUpdateRequest';
import EventsControllerDtoDrawItemCreateResponse from '../model/EventsControllerDtoDrawItemCreateResponse';
import EventsControllerDtoDrawItemDetailRequest from '../model/EventsControllerDtoDrawItemDetailRequest';
import EventsControllerDtoDrawItemDetailResponse from '../model/EventsControllerDtoDrawItemDetailResponse';
import EventsControllerDtoDrawItemListRequest from '../model/EventsControllerDtoDrawItemListRequest';
import EventsControllerDtoDrawItemListResponse from '../model/EventsControllerDtoDrawItemListResponse';
import EventsControllerDtoDrawItemLogListRequest from '../model/EventsControllerDtoDrawItemLogListRequest';
import EventsControllerDtoDrawItemLogListResponse from '../model/EventsControllerDtoDrawItemLogListResponse';
import EventsControllerDtoDrawItemRemoveRequest from '../model/EventsControllerDtoDrawItemRemoveRequest';
import EventsControllerDtoEventFreeNftCreateRequest from '../model/EventsControllerDtoEventFreeNftCreateRequest';
import EventsControllerDtoEventFreeNftDetailRequest from '../model/EventsControllerDtoEventFreeNftDetailRequest';
import EventsControllerDtoEventFreeNftDetailResponse from '../model/EventsControllerDtoEventFreeNftDetailResponse';
import EventsControllerDtoEventFreeNftHistoryListRequest from '../model/EventsControllerDtoEventFreeNftHistoryListRequest';
import EventsControllerDtoEventFreeNftHistoryListResponse from '../model/EventsControllerDtoEventFreeNftHistoryListResponse';
import EventsControllerDtoEventFreeNftListRequest from '../model/EventsControllerDtoEventFreeNftListRequest';
import EventsControllerDtoEventFreeNftListResponse from '../model/EventsControllerDtoEventFreeNftListResponse';
import EventsControllerDtoEventFreeNftRemoveRequest from '../model/EventsControllerDtoEventFreeNftRemoveRequest';
import EventsControllerDtoEventFreeNftUpdateRequest from '../model/EventsControllerDtoEventFreeNftUpdateRequest';
import EventsControllerDtoEventInvitationHistoryListRequest from '../model/EventsControllerDtoEventInvitationHistoryListRequest';
import EventsControllerDtoEventInvitationHistoryListResponse from '../model/EventsControllerDtoEventInvitationHistoryListResponse';
import EventsControllerDtoEventInvitationInfosCreateRequest from '../model/EventsControllerDtoEventInvitationInfosCreateRequest';
import EventsControllerDtoEventInvitationInfosDetailRequest from '../model/EventsControllerDtoEventInvitationInfosDetailRequest';
import EventsControllerDtoEventInvitationInfosDetailResponse from '../model/EventsControllerDtoEventInvitationInfosDetailResponse';
import EventsControllerDtoEventInvitationInfosListRequest from '../model/EventsControllerDtoEventInvitationInfosListRequest';
import EventsControllerDtoEventInvitationInfosListResponse from '../model/EventsControllerDtoEventInvitationInfosListResponse';
import EventsControllerDtoEventInvitationInfosRemoveRequest from '../model/EventsControllerDtoEventInvitationInfosRemoveRequest';
import EventsControllerDtoEventInvitationInfosUpdateRequest from '../model/EventsControllerDtoEventInvitationInfosUpdateRequest';
import EventsControllerDtoEventInvitationPartnerCreateRequest from '../model/EventsControllerDtoEventInvitationPartnerCreateRequest';
import EventsControllerDtoEventInvitationPartnerDetailRequest from '../model/EventsControllerDtoEventInvitationPartnerDetailRequest';
import EventsControllerDtoEventInvitationPartnerDetailResponse from '../model/EventsControllerDtoEventInvitationPartnerDetailResponse';
import EventsControllerDtoEventInvitationPartnerListRequest from '../model/EventsControllerDtoEventInvitationPartnerListRequest';
import EventsControllerDtoEventInvitationPartnerListResponse from '../model/EventsControllerDtoEventInvitationPartnerListResponse';
import EventsControllerDtoEventInvitationPartnerRewardListRequest from '../model/EventsControllerDtoEventInvitationPartnerRewardListRequest';
import EventsControllerDtoEventInvitationPartnerRewardListResponse from '../model/EventsControllerDtoEventInvitationPartnerRewardListResponse';
import EventsControllerDtoEventInvitationPartnerUpdateRequest from '../model/EventsControllerDtoEventInvitationPartnerUpdateRequest';
import EventsControllerDtoEventInvitationRewardListRequest from '../model/EventsControllerDtoEventInvitationRewardListRequest';
import EventsControllerDtoEventInvitationRewardListResponse from '../model/EventsControllerDtoEventInvitationRewardListResponse';
import EventsControllerDtoEventRaffleHistoryListRequest from '../model/EventsControllerDtoEventRaffleHistoryListRequest';
import EventsControllerDtoEventRaffleHistoryListResponse from '../model/EventsControllerDtoEventRaffleHistoryListResponse';
import EventsControllerDtoEventStarterPackHistoryListRequest from '../model/EventsControllerDtoEventStarterPackHistoryListRequest';
import EventsControllerDtoEventStarterPackHistoryListResponse from '../model/EventsControllerDtoEventStarterPackHistoryListResponse';
import EventsControllerDtoEventStarterPackInfoAddBudgetRequest from '../model/EventsControllerDtoEventStarterPackInfoAddBudgetRequest';
import EventsControllerDtoEventStarterPackInfoCreateRequest from '../model/EventsControllerDtoEventStarterPackInfoCreateRequest';
import EventsControllerDtoEventStarterPackInfoDepositRequest from '../model/EventsControllerDtoEventStarterPackInfoDepositRequest';
import EventsControllerDtoEventStarterPackInfoDetailRequest from '../model/EventsControllerDtoEventStarterPackInfoDetailRequest';
import EventsControllerDtoEventStarterPackInfoDetailResponse from '../model/EventsControllerDtoEventStarterPackInfoDetailResponse';
import EventsControllerDtoEventStarterPackInfoListRequest from '../model/EventsControllerDtoEventStarterPackInfoListRequest';
import EventsControllerDtoEventStarterPackInfoListResponse from '../model/EventsControllerDtoEventStarterPackInfoListResponse';
import EventsControllerDtoEventStarterPackInfoRemoveRequest from '../model/EventsControllerDtoEventStarterPackInfoRemoveRequest';
import EventsControllerDtoEventStarterPackInfoUpdateRequest from '../model/EventsControllerDtoEventStarterPackInfoUpdateRequest';
import EventsControllerDtoNoticeListRequest from '../model/EventsControllerDtoNoticeListRequest';
import EventsControllerDtoNoticeListResponse from '../model/EventsControllerDtoNoticeListResponse';
import EventsControllerDtoNoticeRemoveRequest from '../model/EventsControllerDtoNoticeRemoveRequest';
import EventsControllerDtoNoticeSortUpdateRequest from '../model/EventsControllerDtoNoticeSortUpdateRequest';
import EventsControllerDtoRaffleInfoRequest from '../model/EventsControllerDtoRaffleInfoRequest';
import EventsControllerDtoRaffleInfoResponse from '../model/EventsControllerDtoRaffleInfoResponse';
import EventsControllerDtoRaffleListRequest from '../model/EventsControllerDtoRaffleListRequest';
import EventsControllerDtoRaffleListResponse from '../model/EventsControllerDtoRaffleListResponse';
import EventsControllerDtoRaffleUpsertRequest from '../model/EventsControllerDtoRaffleUpsertRequest';

/**
* PerplayEvents service.
* @module api/PerplayEventsApi
* @version 1.0
*/
export default class PerplayEventsApi {

    /**
    * Constructs a new PerplayEventsApi. 
    * @alias module:api/PerplayEventsApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }


    /**
     * Callback function to receive the result of the apiPerplayEventsBannerCreatePost operation.
     * @callback module:api/PerplayEventsApi~apiPerplayEventsBannerCreatePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Date} beginDate 
     * @param {Date} endDate 
     * @param {String} title 
     * @param {String} deeplink 
     * @param {Object} opts Optional parameters
     * @param {String} [region] 
     * @param {Array.<File>} [images] 
     * @param {module:api/PerplayEventsApi~apiPerplayEventsBannerCreatePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiPerplayEventsBannerCreatePost(beginDate, endDate, title, deeplink, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'beginDate' is set
      if (beginDate === undefined || beginDate === null) {
        throw new Error("Missing the required parameter 'beginDate' when calling apiPerplayEventsBannerCreatePost");
      }
      // verify the required parameter 'endDate' is set
      if (endDate === undefined || endDate === null) {
        throw new Error("Missing the required parameter 'endDate' when calling apiPerplayEventsBannerCreatePost");
      }
      // verify the required parameter 'title' is set
      if (title === undefined || title === null) {
        throw new Error("Missing the required parameter 'title' when calling apiPerplayEventsBannerCreatePost");
      }
      // verify the required parameter 'deeplink' is set
      if (deeplink === undefined || deeplink === null) {
        throw new Error("Missing the required parameter 'deeplink' when calling apiPerplayEventsBannerCreatePost");
      }

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
        'BeginDate': beginDate,
        'EndDate': endDate,
        'Title': title,
        'Deeplink': deeplink,
        'Region': opts['region'],
        'Images': this.apiClient.buildCollectionParam(opts['images'], 'passthrough')
      };

      let authNames = ['Bearer'];
      let contentTypes = ['multipart/form-data'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/PerplayEvents/BannerCreate', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayEventsBannerListPost operation.
     * @callback module:api/PerplayEventsApi~apiPerplayEventsBannerListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/EventsControllerDtoBannerListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/EventsControllerDtoBannerListRequest} [eventsControllerDtoBannerListRequest] 
     * @param {module:api/PerplayEventsApi~apiPerplayEventsBannerListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/EventsControllerDtoBannerListResponse}
     */
    apiPerplayEventsBannerListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['eventsControllerDtoBannerListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = EventsControllerDtoBannerListResponse;
      return this.apiClient.callApi(
        '/api/PerplayEvents/BannerList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayEventsBannerRemovePost operation.
     * @callback module:api/PerplayEventsApi~apiPerplayEventsBannerRemovePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/EventsControllerDtoBannerRemoveRequest} [eventsControllerDtoBannerRemoveRequest] 
     * @param {module:api/PerplayEventsApi~apiPerplayEventsBannerRemovePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiPerplayEventsBannerRemovePost(opts, callback) {
      opts = opts || {};
      let postBody = opts['eventsControllerDtoBannerRemoveRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/PerplayEvents/BannerRemove', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayEventsBannerSortUpdatePost operation.
     * @callback module:api/PerplayEventsApi~apiPerplayEventsBannerSortUpdatePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/EventsControllerDtoBannerSortUpdateRequest} [eventsControllerDtoBannerSortUpdateRequest] 
     * @param {module:api/PerplayEventsApi~apiPerplayEventsBannerSortUpdatePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiPerplayEventsBannerSortUpdatePost(opts, callback) {
      opts = opts || {};
      let postBody = opts['eventsControllerDtoBannerSortUpdateRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/PerplayEvents/BannerSortUpdate', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayEventsBannerUpdatePost operation.
     * @callback module:api/PerplayEventsApi~apiPerplayEventsBannerUpdatePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {Number} [bannerNo] 
     * @param {Date} [beginDate] 
     * @param {Date} [endDate] 
     * @param {String} [title] 
     * @param {String} [deeplink] 
     * @param {String} [region] 
     * @param {String} [updateImage] 
     * @param {Boolean} [enabled] 
     * @param {Array.<File>} [images] 
     * @param {String} [imageFileName] 
     * @param {module:api/PerplayEventsApi~apiPerplayEventsBannerUpdatePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiPerplayEventsBannerUpdatePost(opts, callback) {
      opts = opts || {};
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
        'BannerNo': opts['bannerNo'],
        'BeginDate': opts['beginDate'],
        'EndDate': opts['endDate'],
        'Title': opts['title'],
        'Deeplink': opts['deeplink'],
        'Region': opts['region'],
        'UpdateImage': opts['updateImage'],
        'Enabled': opts['enabled'],
        'Images': this.apiClient.buildCollectionParam(opts['images'], 'passthrough'),
        'ImageFileName': opts['imageFileName']
      };

      let authNames = ['Bearer'];
      let contentTypes = ['multipart/form-data'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/PerplayEvents/BannerUpdate', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayEventsEventDrawItemInfoCreatePost operation.
     * @callback module:api/PerplayEventsApi~apiPerplayEventsEventDrawItemInfoCreatePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/EventsControllerDtoDrawItemCreateResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {String} [title] 
     * @param {Number} [perPrice] 
     * @param {Number} [xperPrice] 
     * @param {Number} [itemId] 
     * @param {Number} [itemCount] 
     * @param {Number} [purchaseLimit] 
     * @param {String} [region] 
     * @param {Array.<File>} [images] 
     * @param {Date} [beginAt] 
     * @param {Date} [endAt] 
     * @param {Array.<module:model/EventsControllerDtoDrawItemCreateDrawItemRewardData>} [reward] 
     * @param {module:api/PerplayEventsApi~apiPerplayEventsEventDrawItemInfoCreatePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/EventsControllerDtoDrawItemCreateResponse}
     */
    apiPerplayEventsEventDrawItemInfoCreatePost(opts, callback) {
      opts = opts || {};
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
        'Title': opts['title'],
        'PerPrice': opts['perPrice'],
        'XperPrice': opts['xperPrice'],
        'ItemId': opts['itemId'],
        'ItemCount': opts['itemCount'],
        'PurchaseLimit': opts['purchaseLimit'],
        'Region': opts['region'],
        'Images': this.apiClient.buildCollectionParam(opts['images'], 'passthrough'),
        'BeginAt': opts['beginAt'],
        'EndAt': opts['endAt'],
        'Reward': this.apiClient.buildCollectionParam(opts['reward'], 'multi')
      };

      let authNames = ['Bearer'];
      let contentTypes = ['multipart/form-data'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = EventsControllerDtoDrawItemCreateResponse;
      return this.apiClient.callApi(
        '/api/PerplayEvents/EventDrawItemInfoCreate', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayEventsEventDrawItemInfoDetailPost operation.
     * @callback module:api/PerplayEventsApi~apiPerplayEventsEventDrawItemInfoDetailPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/EventsControllerDtoDrawItemDetailResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/EventsControllerDtoDrawItemDetailRequest} [eventsControllerDtoDrawItemDetailRequest] 
     * @param {module:api/PerplayEventsApi~apiPerplayEventsEventDrawItemInfoDetailPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/EventsControllerDtoDrawItemDetailResponse}
     */
    apiPerplayEventsEventDrawItemInfoDetailPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['eventsControllerDtoDrawItemDetailRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = EventsControllerDtoDrawItemDetailResponse;
      return this.apiClient.callApi(
        '/api/PerplayEvents/EventDrawItemInfoDetail', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayEventsEventDrawItemInfoListPost operation.
     * @callback module:api/PerplayEventsApi~apiPerplayEventsEventDrawItemInfoListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/EventsControllerDtoDrawItemListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/EventsControllerDtoDrawItemListRequest} [eventsControllerDtoDrawItemListRequest] 
     * @param {module:api/PerplayEventsApi~apiPerplayEventsEventDrawItemInfoListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/EventsControllerDtoDrawItemListResponse}
     */
    apiPerplayEventsEventDrawItemInfoListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['eventsControllerDtoDrawItemListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = EventsControllerDtoDrawItemListResponse;
      return this.apiClient.callApi(
        '/api/PerplayEvents/EventDrawItemInfoList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayEventsEventDrawItemInfoRemovePost operation.
     * @callback module:api/PerplayEventsApi~apiPerplayEventsEventDrawItemInfoRemovePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/EventsControllerDtoDrawItemRemoveRequest} [eventsControllerDtoDrawItemRemoveRequest] 
     * @param {module:api/PerplayEventsApi~apiPerplayEventsEventDrawItemInfoRemovePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiPerplayEventsEventDrawItemInfoRemovePost(opts, callback) {
      opts = opts || {};
      let postBody = opts['eventsControllerDtoDrawItemRemoveRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/PerplayEvents/EventDrawItemInfoRemove', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayEventsEventDrawItemInfoUpdatePost operation.
     * @callback module:api/PerplayEventsApi~apiPerplayEventsEventDrawItemInfoUpdatePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {Number} [drawItemNo] 
     * @param {String} [title] 
     * @param {Number} [perPrice] 
     * @param {Number} [xperPrice] 
     * @param {Number} [itemId] 
     * @param {Number} [itemCount] 
     * @param {Number} [purchaseLimit] 
     * @param {Date} [beginAt] 
     * @param {Date} [endAt] 
     * @param {Array.<module:model/EventsControllerDtoDrawItemUpdateDrawItemRewardData>} [reward] 
     * @param {String} [region] 
     * @param {String} [updateImage] 
     * @param {Boolean} [enabled] 
     * @param {Array.<File>} [images] 
     * @param {String} [imageFileName] 
     * @param {module:api/PerplayEventsApi~apiPerplayEventsEventDrawItemInfoUpdatePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiPerplayEventsEventDrawItemInfoUpdatePost(opts, callback) {
      opts = opts || {};
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
        'DrawItemNo': opts['drawItemNo'],
        'Title': opts['title'],
        'PerPrice': opts['perPrice'],
        'XperPrice': opts['xperPrice'],
        'ItemId': opts['itemId'],
        'ItemCount': opts['itemCount'],
        'PurchaseLimit': opts['purchaseLimit'],
        'BeginAt': opts['beginAt'],
        'EndAt': opts['endAt'],
        'Reward': this.apiClient.buildCollectionParam(opts['reward'], 'multi'),
        'Region': opts['region'],
        'UpdateImage': opts['updateImage'],
        'Enabled': opts['enabled'],
        'Images': this.apiClient.buildCollectionParam(opts['images'], 'passthrough'),
        'ImageFileName': opts['imageFileName']
      };

      let authNames = ['Bearer'];
      let contentTypes = ['multipart/form-data'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/PerplayEvents/EventDrawItemInfoUpdate', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayEventsEventDrawItemLogListPost operation.
     * @callback module:api/PerplayEventsApi~apiPerplayEventsEventDrawItemLogListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/EventsControllerDtoDrawItemLogListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/EventsControllerDtoDrawItemLogListRequest} [eventsControllerDtoDrawItemLogListRequest] 
     * @param {module:api/PerplayEventsApi~apiPerplayEventsEventDrawItemLogListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/EventsControllerDtoDrawItemLogListResponse}
     */
    apiPerplayEventsEventDrawItemLogListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['eventsControllerDtoDrawItemLogListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = EventsControllerDtoDrawItemLogListResponse;
      return this.apiClient.callApi(
        '/api/PerplayEvents/EventDrawItemLogList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayEventsEventFreeNftCreatePost operation.
     * @callback module:api/PerplayEventsApi~apiPerplayEventsEventFreeNftCreatePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/EventsControllerDtoEventFreeNftCreateRequest} [eventsControllerDtoEventFreeNftCreateRequest] 
     * @param {module:api/PerplayEventsApi~apiPerplayEventsEventFreeNftCreatePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiPerplayEventsEventFreeNftCreatePost(opts, callback) {
      opts = opts || {};
      let postBody = opts['eventsControllerDtoEventFreeNftCreateRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/PerplayEvents/EventFreeNftCreate', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayEventsEventFreeNftDetailPost operation.
     * @callback module:api/PerplayEventsApi~apiPerplayEventsEventFreeNftDetailPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/EventsControllerDtoEventFreeNftDetailResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/EventsControllerDtoEventFreeNftDetailRequest} [eventsControllerDtoEventFreeNftDetailRequest] 
     * @param {module:api/PerplayEventsApi~apiPerplayEventsEventFreeNftDetailPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/EventsControllerDtoEventFreeNftDetailResponse}
     */
    apiPerplayEventsEventFreeNftDetailPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['eventsControllerDtoEventFreeNftDetailRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = EventsControllerDtoEventFreeNftDetailResponse;
      return this.apiClient.callApi(
        '/api/PerplayEvents/EventFreeNftDetail', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayEventsEventFreeNftHistoryListPost operation.
     * @callback module:api/PerplayEventsApi~apiPerplayEventsEventFreeNftHistoryListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/EventsControllerDtoEventFreeNftHistoryListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/EventsControllerDtoEventFreeNftHistoryListRequest} [eventsControllerDtoEventFreeNftHistoryListRequest] 
     * @param {module:api/PerplayEventsApi~apiPerplayEventsEventFreeNftHistoryListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/EventsControllerDtoEventFreeNftHistoryListResponse}
     */
    apiPerplayEventsEventFreeNftHistoryListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['eventsControllerDtoEventFreeNftHistoryListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = EventsControllerDtoEventFreeNftHistoryListResponse;
      return this.apiClient.callApi(
        '/api/PerplayEvents/EventFreeNftHistoryList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayEventsEventFreeNftListPost operation.
     * @callback module:api/PerplayEventsApi~apiPerplayEventsEventFreeNftListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/EventsControllerDtoEventFreeNftListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/EventsControllerDtoEventFreeNftListRequest} [eventsControllerDtoEventFreeNftListRequest] 
     * @param {module:api/PerplayEventsApi~apiPerplayEventsEventFreeNftListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/EventsControllerDtoEventFreeNftListResponse}
     */
    apiPerplayEventsEventFreeNftListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['eventsControllerDtoEventFreeNftListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = EventsControllerDtoEventFreeNftListResponse;
      return this.apiClient.callApi(
        '/api/PerplayEvents/EventFreeNftList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayEventsEventFreeNftRemovePost operation.
     * @callback module:api/PerplayEventsApi~apiPerplayEventsEventFreeNftRemovePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/EventsControllerDtoEventFreeNftRemoveRequest} [eventsControllerDtoEventFreeNftRemoveRequest] 
     * @param {module:api/PerplayEventsApi~apiPerplayEventsEventFreeNftRemovePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiPerplayEventsEventFreeNftRemovePost(opts, callback) {
      opts = opts || {};
      let postBody = opts['eventsControllerDtoEventFreeNftRemoveRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/PerplayEvents/EventFreeNftRemove', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayEventsEventFreeNftUpdatePost operation.
     * @callback module:api/PerplayEventsApi~apiPerplayEventsEventFreeNftUpdatePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/EventsControllerDtoEventFreeNftUpdateRequest} [eventsControllerDtoEventFreeNftUpdateRequest] 
     * @param {module:api/PerplayEventsApi~apiPerplayEventsEventFreeNftUpdatePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiPerplayEventsEventFreeNftUpdatePost(opts, callback) {
      opts = opts || {};
      let postBody = opts['eventsControllerDtoEventFreeNftUpdateRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/PerplayEvents/EventFreeNftUpdate', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayEventsEventInvitationHistoryListPost operation.
     * @callback module:api/PerplayEventsApi~apiPerplayEventsEventInvitationHistoryListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/EventsControllerDtoEventInvitationHistoryListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/EventsControllerDtoEventInvitationHistoryListRequest} [eventsControllerDtoEventInvitationHistoryListRequest] 
     * @param {module:api/PerplayEventsApi~apiPerplayEventsEventInvitationHistoryListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/EventsControllerDtoEventInvitationHistoryListResponse}
     */
    apiPerplayEventsEventInvitationHistoryListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['eventsControllerDtoEventInvitationHistoryListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = EventsControllerDtoEventInvitationHistoryListResponse;
      return this.apiClient.callApi(
        '/api/PerplayEvents/EventInvitationHistoryList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayEventsEventInvitationInfosCreatePost operation.
     * @callback module:api/PerplayEventsApi~apiPerplayEventsEventInvitationInfosCreatePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/EventsControllerDtoEventInvitationInfosCreateRequest} [eventsControllerDtoEventInvitationInfosCreateRequest] 
     * @param {module:api/PerplayEventsApi~apiPerplayEventsEventInvitationInfosCreatePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiPerplayEventsEventInvitationInfosCreatePost(opts, callback) {
      opts = opts || {};
      let postBody = opts['eventsControllerDtoEventInvitationInfosCreateRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/PerplayEvents/EventInvitationInfosCreate', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayEventsEventInvitationInfosDetailPost operation.
     * @callback module:api/PerplayEventsApi~apiPerplayEventsEventInvitationInfosDetailPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/EventsControllerDtoEventInvitationInfosDetailResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/EventsControllerDtoEventInvitationInfosDetailRequest} [eventsControllerDtoEventInvitationInfosDetailRequest] 
     * @param {module:api/PerplayEventsApi~apiPerplayEventsEventInvitationInfosDetailPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/EventsControllerDtoEventInvitationInfosDetailResponse}
     */
    apiPerplayEventsEventInvitationInfosDetailPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['eventsControllerDtoEventInvitationInfosDetailRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = EventsControllerDtoEventInvitationInfosDetailResponse;
      return this.apiClient.callApi(
        '/api/PerplayEvents/EventInvitationInfosDetail', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayEventsEventInvitationInfosListPost operation.
     * @callback module:api/PerplayEventsApi~apiPerplayEventsEventInvitationInfosListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/EventsControllerDtoEventInvitationInfosListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/EventsControllerDtoEventInvitationInfosListRequest} [eventsControllerDtoEventInvitationInfosListRequest] 
     * @param {module:api/PerplayEventsApi~apiPerplayEventsEventInvitationInfosListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/EventsControllerDtoEventInvitationInfosListResponse}
     */
    apiPerplayEventsEventInvitationInfosListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['eventsControllerDtoEventInvitationInfosListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = EventsControllerDtoEventInvitationInfosListResponse;
      return this.apiClient.callApi(
        '/api/PerplayEvents/EventInvitationInfosList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayEventsEventInvitationInfosRemovePost operation.
     * @callback module:api/PerplayEventsApi~apiPerplayEventsEventInvitationInfosRemovePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/EventsControllerDtoEventInvitationInfosRemoveRequest} [eventsControllerDtoEventInvitationInfosRemoveRequest] 
     * @param {module:api/PerplayEventsApi~apiPerplayEventsEventInvitationInfosRemovePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiPerplayEventsEventInvitationInfosRemovePost(opts, callback) {
      opts = opts || {};
      let postBody = opts['eventsControllerDtoEventInvitationInfosRemoveRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/PerplayEvents/EventInvitationInfosRemove', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayEventsEventInvitationInfosUpdatePost operation.
     * @callback module:api/PerplayEventsApi~apiPerplayEventsEventInvitationInfosUpdatePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/EventsControllerDtoEventInvitationInfosUpdateRequest} [eventsControllerDtoEventInvitationInfosUpdateRequest] 
     * @param {module:api/PerplayEventsApi~apiPerplayEventsEventInvitationInfosUpdatePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiPerplayEventsEventInvitationInfosUpdatePost(opts, callback) {
      opts = opts || {};
      let postBody = opts['eventsControllerDtoEventInvitationInfosUpdateRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/PerplayEvents/EventInvitationInfosUpdate', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayEventsEventInvitationPartnerCreatePost operation.
     * @callback module:api/PerplayEventsApi~apiPerplayEventsEventInvitationPartnerCreatePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/EventsControllerDtoEventInvitationPartnerCreateRequest} [eventsControllerDtoEventInvitationPartnerCreateRequest] 
     * @param {module:api/PerplayEventsApi~apiPerplayEventsEventInvitationPartnerCreatePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiPerplayEventsEventInvitationPartnerCreatePost(opts, callback) {
      opts = opts || {};
      let postBody = opts['eventsControllerDtoEventInvitationPartnerCreateRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/PerplayEvents/EventInvitationPartnerCreate', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayEventsEventInvitationPartnerDetailPost operation.
     * @callback module:api/PerplayEventsApi~apiPerplayEventsEventInvitationPartnerDetailPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/EventsControllerDtoEventInvitationPartnerDetailResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/EventsControllerDtoEventInvitationPartnerDetailRequest} [eventsControllerDtoEventInvitationPartnerDetailRequest] 
     * @param {module:api/PerplayEventsApi~apiPerplayEventsEventInvitationPartnerDetailPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/EventsControllerDtoEventInvitationPartnerDetailResponse}
     */
    apiPerplayEventsEventInvitationPartnerDetailPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['eventsControllerDtoEventInvitationPartnerDetailRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = EventsControllerDtoEventInvitationPartnerDetailResponse;
      return this.apiClient.callApi(
        '/api/PerplayEvents/EventInvitationPartnerDetail', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayEventsEventInvitationPartnerListPost operation.
     * @callback module:api/PerplayEventsApi~apiPerplayEventsEventInvitationPartnerListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/EventsControllerDtoEventInvitationPartnerListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/EventsControllerDtoEventInvitationPartnerListRequest} [eventsControllerDtoEventInvitationPartnerListRequest] 
     * @param {module:api/PerplayEventsApi~apiPerplayEventsEventInvitationPartnerListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/EventsControllerDtoEventInvitationPartnerListResponse}
     */
    apiPerplayEventsEventInvitationPartnerListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['eventsControllerDtoEventInvitationPartnerListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = EventsControllerDtoEventInvitationPartnerListResponse;
      return this.apiClient.callApi(
        '/api/PerplayEvents/EventInvitationPartnerList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayEventsEventInvitationPartnerRewardListPost operation.
     * @callback module:api/PerplayEventsApi~apiPerplayEventsEventInvitationPartnerRewardListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/EventsControllerDtoEventInvitationPartnerRewardListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/EventsControllerDtoEventInvitationPartnerRewardListRequest} [eventsControllerDtoEventInvitationPartnerRewardListRequest] 
     * @param {module:api/PerplayEventsApi~apiPerplayEventsEventInvitationPartnerRewardListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/EventsControllerDtoEventInvitationPartnerRewardListResponse}
     */
    apiPerplayEventsEventInvitationPartnerRewardListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['eventsControllerDtoEventInvitationPartnerRewardListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = EventsControllerDtoEventInvitationPartnerRewardListResponse;
      return this.apiClient.callApi(
        '/api/PerplayEvents/EventInvitationPartnerRewardList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayEventsEventInvitationPartnerUpdatePost operation.
     * @callback module:api/PerplayEventsApi~apiPerplayEventsEventInvitationPartnerUpdatePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/EventsControllerDtoEventInvitationPartnerUpdateRequest} [eventsControllerDtoEventInvitationPartnerUpdateRequest] 
     * @param {module:api/PerplayEventsApi~apiPerplayEventsEventInvitationPartnerUpdatePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiPerplayEventsEventInvitationPartnerUpdatePost(opts, callback) {
      opts = opts || {};
      let postBody = opts['eventsControllerDtoEventInvitationPartnerUpdateRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/PerplayEvents/EventInvitationPartnerUpdate', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayEventsEventInvitationRewardListPost operation.
     * @callback module:api/PerplayEventsApi~apiPerplayEventsEventInvitationRewardListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/EventsControllerDtoEventInvitationRewardListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/EventsControllerDtoEventInvitationRewardListRequest} [eventsControllerDtoEventInvitationRewardListRequest] 
     * @param {module:api/PerplayEventsApi~apiPerplayEventsEventInvitationRewardListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/EventsControllerDtoEventInvitationRewardListResponse}
     */
    apiPerplayEventsEventInvitationRewardListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['eventsControllerDtoEventInvitationRewardListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = EventsControllerDtoEventInvitationRewardListResponse;
      return this.apiClient.callApi(
        '/api/PerplayEvents/EventInvitationRewardList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayEventsEventRaffleHistoryListPost operation.
     * @callback module:api/PerplayEventsApi~apiPerplayEventsEventRaffleHistoryListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/EventsControllerDtoEventRaffleHistoryListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/EventsControllerDtoEventRaffleHistoryListRequest} [eventsControllerDtoEventRaffleHistoryListRequest] 
     * @param {module:api/PerplayEventsApi~apiPerplayEventsEventRaffleHistoryListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/EventsControllerDtoEventRaffleHistoryListResponse}
     */
    apiPerplayEventsEventRaffleHistoryListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['eventsControllerDtoEventRaffleHistoryListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = EventsControllerDtoEventRaffleHistoryListResponse;
      return this.apiClient.callApi(
        '/api/PerplayEvents/EventRaffleHistoryList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayEventsEventRaffleInfoPost operation.
     * @callback module:api/PerplayEventsApi~apiPerplayEventsEventRaffleInfoPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/EventsControllerDtoRaffleInfoResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/EventsControllerDtoRaffleInfoRequest} [eventsControllerDtoRaffleInfoRequest] 
     * @param {module:api/PerplayEventsApi~apiPerplayEventsEventRaffleInfoPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/EventsControllerDtoRaffleInfoResponse}
     */
    apiPerplayEventsEventRaffleInfoPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['eventsControllerDtoRaffleInfoRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = EventsControllerDtoRaffleInfoResponse;
      return this.apiClient.callApi(
        '/api/PerplayEvents/EventRaffleInfo', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayEventsEventRaffleListPost operation.
     * @callback module:api/PerplayEventsApi~apiPerplayEventsEventRaffleListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/EventsControllerDtoRaffleListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/EventsControllerDtoRaffleListRequest} [eventsControllerDtoRaffleListRequest] 
     * @param {module:api/PerplayEventsApi~apiPerplayEventsEventRaffleListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/EventsControllerDtoRaffleListResponse}
     */
    apiPerplayEventsEventRaffleListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['eventsControllerDtoRaffleListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = EventsControllerDtoRaffleListResponse;
      return this.apiClient.callApi(
        '/api/PerplayEvents/EventRaffleList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayEventsEventRaffleUpsertPost operation.
     * @callback module:api/PerplayEventsApi~apiPerplayEventsEventRaffleUpsertPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/EventsControllerDtoRaffleUpsertRequest} [eventsControllerDtoRaffleUpsertRequest] 
     * @param {module:api/PerplayEventsApi~apiPerplayEventsEventRaffleUpsertPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiPerplayEventsEventRaffleUpsertPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['eventsControllerDtoRaffleUpsertRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/PerplayEvents/EventRaffleUpsert', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayEventsEventStarterPackHistoryListPost operation.
     * @callback module:api/PerplayEventsApi~apiPerplayEventsEventStarterPackHistoryListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/EventsControllerDtoEventStarterPackHistoryListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/EventsControllerDtoEventStarterPackHistoryListRequest} [eventsControllerDtoEventStarterPackHistoryListRequest] 
     * @param {module:api/PerplayEventsApi~apiPerplayEventsEventStarterPackHistoryListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/EventsControllerDtoEventStarterPackHistoryListResponse}
     */
    apiPerplayEventsEventStarterPackHistoryListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['eventsControllerDtoEventStarterPackHistoryListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = EventsControllerDtoEventStarterPackHistoryListResponse;
      return this.apiClient.callApi(
        '/api/PerplayEvents/EventStarterPackHistoryList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayEventsEventStarterPackInfoAddBudgetPost operation.
     * @callback module:api/PerplayEventsApi~apiPerplayEventsEventStarterPackInfoAddBudgetPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/EventsControllerDtoEventStarterPackInfoAddBudgetRequest} [eventsControllerDtoEventStarterPackInfoAddBudgetRequest] 
     * @param {module:api/PerplayEventsApi~apiPerplayEventsEventStarterPackInfoAddBudgetPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiPerplayEventsEventStarterPackInfoAddBudgetPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['eventsControllerDtoEventStarterPackInfoAddBudgetRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/PerplayEvents/EventStarterPackInfoAddBudget', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayEventsEventStarterPackInfoCreatePost operation.
     * @callback module:api/PerplayEventsApi~apiPerplayEventsEventStarterPackInfoCreatePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/EventsControllerDtoEventStarterPackInfoCreateRequest} [eventsControllerDtoEventStarterPackInfoCreateRequest] 
     * @param {module:api/PerplayEventsApi~apiPerplayEventsEventStarterPackInfoCreatePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiPerplayEventsEventStarterPackInfoCreatePost(opts, callback) {
      opts = opts || {};
      let postBody = opts['eventsControllerDtoEventStarterPackInfoCreateRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/PerplayEvents/EventStarterPackInfoCreate', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayEventsEventStarterPackInfoDepositPost operation.
     * @callback module:api/PerplayEventsApi~apiPerplayEventsEventStarterPackInfoDepositPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/EventsControllerDtoEventStarterPackInfoDepositRequest} [eventsControllerDtoEventStarterPackInfoDepositRequest] 
     * @param {module:api/PerplayEventsApi~apiPerplayEventsEventStarterPackInfoDepositPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiPerplayEventsEventStarterPackInfoDepositPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['eventsControllerDtoEventStarterPackInfoDepositRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/PerplayEvents/EventStarterPackInfoDeposit', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayEventsEventStarterPackInfoDetailPost operation.
     * @callback module:api/PerplayEventsApi~apiPerplayEventsEventStarterPackInfoDetailPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/EventsControllerDtoEventStarterPackInfoDetailResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/EventsControllerDtoEventStarterPackInfoDetailRequest} [eventsControllerDtoEventStarterPackInfoDetailRequest] 
     * @param {module:api/PerplayEventsApi~apiPerplayEventsEventStarterPackInfoDetailPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/EventsControllerDtoEventStarterPackInfoDetailResponse}
     */
    apiPerplayEventsEventStarterPackInfoDetailPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['eventsControllerDtoEventStarterPackInfoDetailRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = EventsControllerDtoEventStarterPackInfoDetailResponse;
      return this.apiClient.callApi(
        '/api/PerplayEvents/EventStarterPackInfoDetail', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayEventsEventStarterPackInfoListPost operation.
     * @callback module:api/PerplayEventsApi~apiPerplayEventsEventStarterPackInfoListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/EventsControllerDtoEventStarterPackInfoListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/EventsControllerDtoEventStarterPackInfoListRequest} [eventsControllerDtoEventStarterPackInfoListRequest] 
     * @param {module:api/PerplayEventsApi~apiPerplayEventsEventStarterPackInfoListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/EventsControllerDtoEventStarterPackInfoListResponse}
     */
    apiPerplayEventsEventStarterPackInfoListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['eventsControllerDtoEventStarterPackInfoListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = EventsControllerDtoEventStarterPackInfoListResponse;
      return this.apiClient.callApi(
        '/api/PerplayEvents/EventStarterPackInfoList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayEventsEventStarterPackInfoRemovePost operation.
     * @callback module:api/PerplayEventsApi~apiPerplayEventsEventStarterPackInfoRemovePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/EventsControllerDtoEventStarterPackInfoRemoveRequest} [eventsControllerDtoEventStarterPackInfoRemoveRequest] 
     * @param {module:api/PerplayEventsApi~apiPerplayEventsEventStarterPackInfoRemovePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiPerplayEventsEventStarterPackInfoRemovePost(opts, callback) {
      opts = opts || {};
      let postBody = opts['eventsControllerDtoEventStarterPackInfoRemoveRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/PerplayEvents/EventStarterPackInfoRemove', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayEventsEventStarterPackInfoUpdatePost operation.
     * @callback module:api/PerplayEventsApi~apiPerplayEventsEventStarterPackInfoUpdatePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/EventsControllerDtoEventStarterPackInfoUpdateRequest} [eventsControllerDtoEventStarterPackInfoUpdateRequest] 
     * @param {module:api/PerplayEventsApi~apiPerplayEventsEventStarterPackInfoUpdatePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiPerplayEventsEventStarterPackInfoUpdatePost(opts, callback) {
      opts = opts || {};
      let postBody = opts['eventsControllerDtoEventStarterPackInfoUpdateRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/PerplayEvents/EventStarterPackInfoUpdate', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayEventsNoticeCreatePost operation.
     * @callback module:api/PerplayEventsApi~apiPerplayEventsNoticeCreatePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Date} beginDate 
     * @param {Date} endDate 
     * @param {String} title 
     * @param {String} deeplink 
     * @param {Object} opts Optional parameters
     * @param {String} [region] 
     * @param {Array.<File>} [images] 
     * @param {String} [noticeInfo] 
     * @param {Number} [noticeType] 
     * @param {module:api/PerplayEventsApi~apiPerplayEventsNoticeCreatePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiPerplayEventsNoticeCreatePost(beginDate, endDate, title, deeplink, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'beginDate' is set
      if (beginDate === undefined || beginDate === null) {
        throw new Error("Missing the required parameter 'beginDate' when calling apiPerplayEventsNoticeCreatePost");
      }
      // verify the required parameter 'endDate' is set
      if (endDate === undefined || endDate === null) {
        throw new Error("Missing the required parameter 'endDate' when calling apiPerplayEventsNoticeCreatePost");
      }
      // verify the required parameter 'title' is set
      if (title === undefined || title === null) {
        throw new Error("Missing the required parameter 'title' when calling apiPerplayEventsNoticeCreatePost");
      }
      // verify the required parameter 'deeplink' is set
      if (deeplink === undefined || deeplink === null) {
        throw new Error("Missing the required parameter 'deeplink' when calling apiPerplayEventsNoticeCreatePost");
      }

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
        'BeginDate': beginDate,
        'EndDate': endDate,
        'Title': title,
        'Deeplink': deeplink,
        'Region': opts['region'],
        'Images': this.apiClient.buildCollectionParam(opts['images'], 'passthrough'),
        'NoticeInfo': opts['noticeInfo'],
        'NoticeType': opts['noticeType']
      };

      let authNames = ['Bearer'];
      let contentTypes = ['multipart/form-data'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/PerplayEvents/NoticeCreate', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayEventsNoticeListPost operation.
     * @callback module:api/PerplayEventsApi~apiPerplayEventsNoticeListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/EventsControllerDtoNoticeListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/EventsControllerDtoNoticeListRequest} [eventsControllerDtoNoticeListRequest] 
     * @param {module:api/PerplayEventsApi~apiPerplayEventsNoticeListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/EventsControllerDtoNoticeListResponse}
     */
    apiPerplayEventsNoticeListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['eventsControllerDtoNoticeListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = EventsControllerDtoNoticeListResponse;
      return this.apiClient.callApi(
        '/api/PerplayEvents/NoticeList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayEventsNoticeRemovePost operation.
     * @callback module:api/PerplayEventsApi~apiPerplayEventsNoticeRemovePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/EventsControllerDtoNoticeRemoveRequest} [eventsControllerDtoNoticeRemoveRequest] 
     * @param {module:api/PerplayEventsApi~apiPerplayEventsNoticeRemovePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiPerplayEventsNoticeRemovePost(opts, callback) {
      opts = opts || {};
      let postBody = opts['eventsControllerDtoNoticeRemoveRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/PerplayEvents/NoticeRemove', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayEventsNoticeSortUpdatePost operation.
     * @callback module:api/PerplayEventsApi~apiPerplayEventsNoticeSortUpdatePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/EventsControllerDtoNoticeSortUpdateRequest} [eventsControllerDtoNoticeSortUpdateRequest] 
     * @param {module:api/PerplayEventsApi~apiPerplayEventsNoticeSortUpdatePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiPerplayEventsNoticeSortUpdatePost(opts, callback) {
      opts = opts || {};
      let postBody = opts['eventsControllerDtoNoticeSortUpdateRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/PerplayEvents/NoticeSortUpdate', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayEventsNoticeUpdatePost operation.
     * @callback module:api/PerplayEventsApi~apiPerplayEventsNoticeUpdatePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {Number} [noticeNo] 
     * @param {Date} [beginDate] 
     * @param {Date} [endDate] 
     * @param {String} [title] 
     * @param {String} [deeplink] 
     * @param {String} [region] 
     * @param {String} [updateImage] 
     * @param {Boolean} [enabled] 
     * @param {Array.<File>} [images] 
     * @param {String} [imageFileName] 
     * @param {String} [noticeInfo] 
     * @param {Number} [noticeType] 
     * @param {module:api/PerplayEventsApi~apiPerplayEventsNoticeUpdatePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiPerplayEventsNoticeUpdatePost(opts, callback) {
      opts = opts || {};
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
        'NoticeNo': opts['noticeNo'],
        'BeginDate': opts['beginDate'],
        'EndDate': opts['endDate'],
        'Title': opts['title'],
        'Deeplink': opts['deeplink'],
        'Region': opts['region'],
        'UpdateImage': opts['updateImage'],
        'Enabled': opts['enabled'],
        'Images': this.apiClient.buildCollectionParam(opts['images'], 'passthrough'),
        'ImageFileName': opts['imageFileName'],
        'NoticeInfo': opts['noticeInfo'],
        'NoticeType': opts['noticeType']
      };

      let authNames = ['Bearer'];
      let contentTypes = ['multipart/form-data'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/PerplayEvents/NoticeUpdate', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }


}
